export const API_URLS = {
    GET_SUGGESTIONS: '/api/search/suggestions',
    GET_ARTICLES: '/lcci-api/listings/articles',
    GET_COURSES: '/lcci-api/listings/courses',
    GET_OFFERS: '/lcci-api/listings/offers',
    GET_PUBLICATIONS: '/lcci-api/listings/publications',
    GET_MAGAZINES: '/lcci-api/listings/magazines',
    GET_MEMBERS_DIRECTORY: '/lcci-api/members-directory/search',
    GET_EVENTS: '/lcci-api/listings/events',
    GET_EVENTS_PAGE_FROM_HASH: '/lcci-api/listings/getpagefromhash',
    NEWSLETTER_SIGNUP: 'api/newsletter',
    // Membership sign up form
    MEMBERSHIP_STAGE_ONE: '/api/register/step1',
    MEMBERSHIP_STAGE_TWO: '/api/register/step2',
    MEMBERSHIP_COST_CHECK: '/api/register/step2/membership-estimate',
    MEMBERSHIP_SUBMIT: '/api/register/submit',
    MEMBERSHIP_ABANDON: '/api/register/abandon',
    COMMUNITY_SIGNUP: '/api/community/register',
    GET_SEARCH_RESULTS: '/lcci-api/search/perform',
    SUBMIT_BOOK_EVENT_STEP1: '/api/events/book/step1',
    SUBMIT_BOOK_EVENT_STEP2: '/api/events/book/step2',
    SUBMIT_BOOK_EVENT_APPLY_DISCOUNT: '/api/events/book/apply-discount',
    SUBMIT_BOOK_EVENT: '/api/events/book/submit',
    SUBMIT_EVENT_EDIT_FORM: '/api/events/manage',
    SUBMIT_MEMBERS_DIRECTORY_SEARCH: 'api/members-directory/search',
    SUBMIT_EVENT_FORM: '/lcci-api/event/upload',
    SUBMIT_VENUE_FORM: '/lcci-api/venue/upload',
    SUBMIT_PASSWORD_RESET: '/api/auth/reset-password',
    SUBMIT_CHANGE_PASSWORD: '/api/account/change-password',
    SUBMIT_OFFER_FORM: '/lcci-api/offer/upload',
    GET_LOGO: '/api/membership/request/logo-download',
    UPDATE_DETAILS_FORM: '/api/account/update-details',
    UPDATE_COMPANY_DETAILS_FORM: '/api/account/update-company-details',
    MANAGE_EMPLOYEES_FORM: '/lcci-api/profile/manage-employees',
    GET_EMPLOYEES: '/lcci-api/profile/get-employees',
    // Event sign in form
    GET_EVENT_DELEGATES: '/lcci-api/event-sign-in/get-event-delegates',
    ADD_EVENT_ATTENDEE: '/lcci-api/event-sign-in/add-event-attendee',
    FIND_CONTACT: '/lcci-api/event-sign-in/find-contact',
    ADD_ON_SITE_DELEGATE: '/lcci-api/event-sign-in/add-on-site-delegate',
};
